/**
 * Internal — exposes the AuthContext for the provider implementations
 * (real + fake) to share. Not intended as a public API.
 */
import * as React from "react";
import type { AuthState } from "./useAuth";

export const AuthContext = React.createContext<AuthState | null>(null);
